import { LeftSectionTableTranslations } from "./types";

export const deTranslations: LeftSectionTableTranslations = {
    disease: "Krankheit",
    students: "Studierende",
    patients: "Patient:innen",
    diagnosis: "Diagnose",
    avg_score: "Durchschnittsscore",
    noRecordAvailable: "keine Aufzeichnung vorhanden"
};